<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">

  
    <img src="@/assets/diisco.png" class="bola bola-izquierda" alt="" />

    <div class="imagen-xv-shell" ref="imagenRef">
      <div class="imagen-xv-wrapper">
        <img
          src="@/assets/3.webp"
          class="imagen-xv"
        />
      </div>
    </div><br>

    <section class="texto-xv">

      <p class="frase-bendicion animar-scroll">
       <br /> With God's blessing <br />
        and my parents'<br /><br />
      </p>

      <div class="separador-elegante animar-scroll"></div>

      <div class="nombres-container animar-scroll">
        <h1 class="nombre-protagonista">Patricia &nbsp;Rivera</h1>
        <h1 class="nombre-protagonista">
          Roldan &nbsp;Rivera 
          <i class="fas fa-cross cruz-fallecido"></i>
        </h1>
      </div>
      
      <p class="parrafo-presentacion animar-scroll">
       Join me in celebrating the beginning of this new chapter in my life.<br><br>
      </p>

      <div class="impacto-container">
        <h1 class="dulces-impacto">
          <span class="palabra">My</span>
          <span class="palabra">Sweet</span>
          <span class="numero">16</span>
        </h1>
        <br /> 
       
      </div>

    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)
    const imagenRef = ref(null)

    onMounted(async () => {
      await nextTick()

      // 1. Animación de la Imagen Principal (entra al cargar)
      gsap.from(imagenRef.value, {
        opacity: 0,
        scale: 0.8,
        duration: 1.5,
        ease: "expo.out"
      })

      // 2. Animación CASCADA para los textos conforme bajas
      const elementos = document.querySelectorAll('.animar-scroll')
      
      elementos.forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 90%", // Empieza cuando el elemento asoma por abajo
            toggleActions: "play none none none"
          },
          opacity: 0,
          y: 30,
          duration: 1,
          ease: "power2.out"
        })
      })

      // 3. Animación ESPECIAL para "Mis Dulces 16"
      const tlWow = gsap.timeline({
        scrollTrigger: {
          trigger: ".dulces-impacto",
          start: "top 85%",
          toggleActions: "play none none none"
        }
      })

      tlWow.from(".palabra", {
        opacity: 0,
        y: 40,
        stagger: 0.2,
        duration: 0.8,
        ease: "power3.out"
      })
      .from(".numero", {
        scale: 0,
        rotation: 180,
        opacity: 0,
        duration: 1.2,
        ease: "back.out(1.7)"
      }, "-=0.5")
      .from(".fecha-impacto", {
        opacity: 0,
        y: 20,
        duration: 0.8
      }, "-=0.5")
    })

    return { rootRef, imagenRef }
  }
}
</script>

<style scoped>
/* ========================
   CONTENEDOR PRINCIPAL
======================== */
.portada-xv{
  position:relative;
  width:100%;
  min-height:45vh;
  background:#f3f7fd;
  overflow:visible;
  display:flex;
  margin-top:-50px;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:0px 16px 0px;
}

/* ========================
   IMAGEN PRINCIPAL
======================== */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow: 0 12px 40px rgba(0,0,0,.18);
  position: relative;
}

.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* ========================
   TEXTO GENERAL
======================== */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: -22px;
  padding: 0 8px;
}

.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}

.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
}

.nombre-protagonista{
  font-family: "titulos", cursive;
  font-size: 52px;
  color:#043b73;
  margin: 0;
  line-height:1.1;
}

.parrafo-presentacion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 16px);
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 30px;
}

/* ========================
   MIS DULCES 16
======================== */
.dulces-impacto{
  margin-top: 40px;
  text-align: center;
  font-family: 'Playfair Display', serif;
}

.palabra{
  display: inline-block;
  font-size: 36px;
  margin: 0 6px;
  color:#6a6a6a;
}

.numero{
  display: block;
  font-size: 85px;
  font-family: 'Playfair Display', serif;
  color:#043b73;
  text-shadow: 0 0 10px rgba(4,59,115,0.2);
}

.fecha-impacto{
  margin-top: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  letter-spacing: 4px;
  color:#043b73;
}

/* ========================
   FLORES Y OTROS
======================== */
.flor{ position:absolute; width:min(44vw, 240px); z-index:10; }
.flor-1{ top:-20px; left:-60px; }
.flor-2{ top:25px; right:-70px; z-index:2; transform: rotate(20deg); }

.cruz-fallecido{
  font-size: 20px;
  color: #535456;
  opacity: 0.8;
  vertical-align: middle;
}

.bola{ position:absolute; width:210px; animation: girar 10s linear infinite; opacity:.85; z-index:1; }
.bola-izquierda{ left:207px; bottom:-128px; z-index:9;}

@keyframes girar {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}
</style>